import { v4 as uuidv4 } from 'uuid';

const sessionIDStorageKey = 'streamsix_session_id';

const getLocationDefaultKeyReplacement = (): string => {
    return uuidv4();
};

const getSessionID = (): string => {
    const savedSessionID = sessionStorage.getItem(sessionIDStorageKey);
    if (!savedSessionID) {
        const newSessionID = uuidv4();
        sessionStorage.setItem(sessionIDStorageKey, newSessionID);
        return newSessionID;
    }
    return savedSessionID;
};

export const locationDefaultKeyReplacement = getLocationDefaultKeyReplacement();
export const sessionID = getSessionID();
export let firstRender = true;
export const setFirstRender = (value: boolean) => {
    firstRender = value;
};

export const getFileFromURL = async (url: string): Promise<File | undefined> => {
    if (!!url) {
        const resp = await fetch(url);
        if (!!resp) {
            const blob = await resp.blob();
            if (!!blob) {
                const file = new File([blob], crypto.randomUUID());
                return file;
            }
        }
    }
    return undefined;
};
